import { Link } from 'react-router-dom';
import './HomeComponents.css';

const DonationHero = () => {
  return (
    <section className="donation-hero">
      <div className="donation-hero-inner">
        <div className="donation-hero-copy">
          <div className="donation-heart">❤️</div>
          <h2>Give Help, <span>Not Just Money</span></h2>
          <p>
            Your donation directly funds essential support for people in need - groceries, transportation, urgent
            repairs, and more. <strong>100% goes to real people, never for profit.</strong> Together, we make sure no one
            faces a challenge alone.
          </p>
          <Link to="/Donation.html" className="donation-btn">Donate Now →</Link>
        </div>
        <div className="donation-hero-card">❤️ Help Others</div>
      </div>
    </section>
  );
};

export default DonationHero;